export class GetLocationByCode {
    constructor() {
        this.handle = async (code) => {
            const apiUrl = process.env.REACT_APP_API_URL;
            try {
                const url = new URL(`/locations-code/${code}`, apiUrl);
                const response = await fetch(url.toString(), {
                    method: 'get',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const data = await response.json();
                return data;
            }
            catch (error) {
                return console.error(error);
            }
        };
        this.formatedd = async (code) => {
            const apiUrl = process.env.REACT_APP_API_URL;
            try {
                const url = new URL(`/location-code-formatted/${code}`, apiUrl);
                const response = await fetch(url.toString(), {
                    method: 'get',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const data = await response.json();
                return data;
            }
            catch (error) {
                return console.error(error);
            }
        };
    }
}
